// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__25yqb","label":"styles_label__2w1wj"};